import {GateElement, type GateElementOptions, GateStyle} from "../elements/GateElement";
import {type PanelOptions} from "../../PanelOptionsLogic";
import {PanelElement} from "../elements/PanelElement";

const PreviewGateStyle = {
    gate: {
        ...GateStyle.gate,
        display: "flex",
        flexDirection: "column",
        position: "absolute",
        boxSizing: "border-box",
        width: "100%",
        top: 0,
        left: 0,
    },
};

// The four preview fields are the panel options of the same name, so they are taken from there rather
// than restated - PanelOptionsLogic's comments are their documentation
export interface PreviewGateOptions extends GateElementOptions,
    Partial<Pick<PanelOptions, "previewHeight" | "previewFadeOut" | "previewFadeOutHeight" | "previewFadeOutToColor">> {}

export class PreviewGate extends GateElement {
    declare options: PreviewGateOptions;

    styleSheet = PreviewGateStyle;
    preview: HTMLDivElement;
    fadeOut?: HTMLDivElement;

    constructor(options: PreviewGateOptions, panel: PanelElement) {
        super(options, panel);

        this.preview = document.createElement("div");
        this.node.appendChild(this.preview);

        if (this.options.previewFadeOut) {
            this.fadeOut = document.createElement("div");

            Object.assign(this.fadeOut.style, {
                background: `linear-gradient(rgba(255,255,255,0),${this.options.previewFadeOutToColor})`,
                height: this.options.previewFadeOutHeight + "px",
            });

            this.node.appendChild(this.fadeOut);
        }
    }

    refreshStyle() {
        super.refreshStyle();
        Object.assign(this.preview.style, {
            height: this.options.previewHeight + "px",
        });
        this.setStyle(this.options.customStyle ?? {});
    }

    getPanelStyle() {
        return {
            ...super.getPanelStyle(),
            background: this.options.previewFadeOutToColor,
        };
    }

    computeParentStyle() {
        const height = (this.preview?.offsetHeight || 0) +
            (this.fadeOut?.offsetHeight || 0) + Number(this.panel?.height || 0) + "px";

        return {
            ...super.computeParentStyle(),
            overflow: "hidden",
            minHeight: height,
            maxHeight: height,
            height
        };
    }
}
